import {
  sendAuthenticatedAsyncRequest,
  sendCustomersApiServiceAuthenticatedRequest,
} from "services/AsyncRequestService";

const requestAsPromise = (sendRequest, url, method, body) =>
  new Promise((resolve, reject) => {
    sendRequest(
      url,
      method,
      body,
      (response) => resolve(response.data),
      reject
    );
  });

export const fetchClientCustomerFilters = () =>
  requestAsPromise(
    sendCustomersApiServiceAuthenticatedRequest,
    "/customers/customers-clients",
    "GET",
    null
  );

export const createPawGroup = (payload) =>
  requestAsPromise(
    sendAuthenticatedAsyncRequest,
    "/paw-group/create-paw-groups",
    "POST",
    payload
  );
